module.exports = __webpack_public_path__ + "static/media/mosaic-iphone.1e67205a.jpg";